export const DOCUMENT_NAME_MAX_LENGTH = 100;

// Count Unicode code points so an emoji is not split into surrogate halves.
export const truncateDocumentName = (
  value: string,
  maxLength = DOCUMENT_NAME_MAX_LENGTH
): string => Array.from(value).slice(0, maxLength).join('');

export const isValidDocumentName = (value: string): boolean =>
  value.trim().length > 0 &&
  Array.from(value).length <= DOCUMENT_NAME_MAX_LENGTH;

// Display names stay in metadata and process payloads. Storage keys must not
// inherit path separators, reserved characters or the display name's byte size.
export const getStorageObjectName = (name: string): string => {
  const extension = name.match(/\.([a-z0-9]{1,10})$/i)?.[0] ?? '';
  return `file${extension}`;
};
